<template>
    <div>
        <div class="listbox company_manage">
                <button class="creatbtn" @click="tocreat" v-hasbtn="'/role/creat'">
                    + 新建角色
                </button>
                <div :style="data1.length==0?'':'min-height:calc(100vh - 580px)'">
                    <Table stripe :columns="columns1" :data="data1" disabled-hover :no-data-text="''"></Table>
                </div>
                <div style="text-align: center;padding: 66px 0;" v-show="data1.length==0">
                    <p><img src="@/assets/img/nomessage.png"></p>
                    <h1 style="font-size: 16px;padding: 10px 0;color:#101d37">未查询到相关数据</h1>
                </div>
                <div style="margin-top:20px;">
                    <div slot style="display: inline-block;line-height: 30px;color: #9f9f9f">
                        共 {{total}} 条记录  第 {{pageNo}}/{{allpage}} 页
                    </div>
                    <Page :total="total" show-elevator :page-size="pageSize"  @on-change="pagechange">

                    </Page>
                </div>

        </div>
        <Modal
        v-model="stopModel"
        title="提示!"
        @on-ok="stopok"
        @on-cancel="stopModel=false;chooseId='';">
        <p>确定删除此帐号?</p>
    </Modal>
    </div>
</template>
<script>
import { admin } from '@/api/admin'
import { hasbtn } from '@/utils/commondata'
export default {
    name: 'HelloWorld',
    props: {
        msg: String
    },
    data(){
        return{
            chooseId:'',
            total:100,
            allpage:10,
            pageNo:1,
            pageSize:10,
            stopModel:false,
            columns1: [
                // {
                //         title: ' ',
                //         align:'center',
                //         width:60,
                //         render : (h, params) => {
                //             return [
                //                 h('div', {
                //                     props: {
                //                         type: 'text'
                //                     }
                //                 }, params.index+1)
                //             ]
                //         }
                //     },
                    {
                        title: '角色名',
                        width:'200',
                        align:'center',
                        key: 'roleName'
                    },
                    {
                        title: '描述',
                        align:'center',
                        key: 'description',
                        render : (h, params) => {
                            return [
                                h('div', {
                                    props: {
                                        type: 'text'
                                    },
                                }, params.row.description?params.row.description:'--')
                            ]
                        }
                    },
                    {
                        title: '操作',
                        key: 'sale',
                        width:'200',
                        align:'center',
                        render: (h, params) => {
                            if(params.row.isDefault=='0'){
                                return h('div', [
                                    h('Button', {
                                        props: {
                                            type: 'text',
                                            size: 'small'
                                        },
                                        style: {
                                            color: '#3569fd',
                                            fontSize:'14px'
                                        },
                                        on: {
                                            click: () => {
                                                if(hasbtn(this.$router.options.routes[1].children,'/role/look')){
                                                    this.$router.push({path:'/role/look',query:{id:params.row.roleId,type:'look'}})
                                                }

                                            }
                                        }
                                    }, hasbtn(this.$router.options.routes[1].children,'/role/look')?'查看':''),
                                    h('Button', {

                                        props: {
                                            type: 'text',
                                            size: 'small'
                                        },
                                        style:{
                                            color: '#101d37'
                                        },
                                        on:{
                                            click:()=>{
                                                if(hasbtn(this.$router.options.routes[1].children,'/role/edit')){
                                                    this.$router.push({path:'/role/edit',query:{id:params.row.roleId}})
                                                }

                                            }
                                        }
                                    }, hasbtn(this.$router.options.routes[1].children,'/role/edit')?'修改':''),
                                    h('Button', {
                                        props: {
                                            type: 'text',
                                            size: 'small'
                                        },
                                        style:{
                                            color: '#afafaf'
                                        },
                                        on:{
                                            click:()=>{
                                                this.chooseId=params.row.roleId;
                                                this.stopModel=true;
                                            }
                                        }
                                    }, '删除')
                                ])
                            }else{
                                return h('div', [
                                    h('Button', {
                                        props: {
                                            type: 'text',
                                            size: 'small'
                                        },
                                        style: {
                                            color: '#3569fd',
                                            fontSize:'14px',
                                        },
                                        on: {
                                            click: () => {
                                                if(hasbtn(this.$router.options.routes[1].children,'/role/look')){
                                                    this.$router.push({path:'/role/look',query:{id:params.row.roleId,type:'look'}})
                                                }
                                            }
                                        }
                                    }, hasbtn(this.$router.options.routes[1].children,'/role/look')?'查看':'')
                                ])
                            }

                        }
                    }
                ],
                data1: []

        }
    },
    mounted(){
        this.getlist();
    },
    methods:{
        tocreat(){
            this.$router.push('/role/creat');//创建系统固定的角色  不可修改
            //this.$router.push('/role/usercreat')//用户新创建的角色  可修改
        },
        getlist(){
            admin.getroleList(this.pageNo,this.pageSize).then(res=>{
                if(res.data.success==true){
                    this.data1=res.data.result.records;
                    this.total=res.data.result.total;
                    this.allpage=res.data.result.pages?res.data.result.pages:1
                }
            })
        },
        pagechange(n){
            this.pageNo=n;
            this.getlist();
        },
        stopok(){
            admin.delrole(this.chooseId).then(res=>{
                if(res.data.success==true){
                    this.$Message.success(res.data.message);
                    this.getlist();
                }else{
                    this.$Message.error(res.data.message);
                }
            })
        }
    }
}
</script>

<style scoped>
    .filterbox{
        height: 184px;
        box-sizing: border-box;
        padding: 40px 60px 40px 40px;
        background-color: #ffffff;
        box-shadow: 0px 0px 21px 0px
            rgba(191, 199, 221, 0.26);
        border-radius: 4px;
    }
    .filtertxt{
        width:80%;
        display: inline-block;
        vertical-align: middle;
    }
    .labeltxt{
        color: #101d37;
        font-size: 14px;
    }
    .filterbtn{
        width:19%;
        display: inline-block;
        text-align: right;
        padding-right: 60px;
        vertical-align: middle;
    }
    .filterbtn button{
        border: none;
        color: #ffffff;
        width: 132px;
        height: 42px;
        background-color: #26ce95;
        box-shadow: 0px 4px 6px 0px
            rgba(38, 206, 149, 0.22);
        border-radius: 3px;
        line-height: 42px;

    }
    .listbox{
       padding: 40px 23px 33px 30px;
    }
    .creatbtn{
        width: 132px;
        height: 42px;
        background-color: #f7f9fc;
        border-radius: 4px;
        color: #3569fd;
        font-size: 16px;
        border: none;
        margin-bottom: 20px;
    }

</style>

